import {
  PlanFactoryModuleGate,
  planFactoryRoutes,
  selectPlanFactoryPermissions,
} from '@redirecthealth/plan-factory-ui';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { AuthorityGuard } from './AuthorityGuard';

/**
 * Mounts the package routes under /plan-factory/*, the way rnav mounts claims.
 * The host guard reads the user's codes from the package's /v1/me session; rnav
 * reads its own permission store instead. The package checks again either way.
 */
export function PlanFactoryMount() {
  const { t } = useTranslation();
  const granted = useSelector(selectPlanFactoryPermissions);
  return (
    <PlanFactoryModuleGate>
      <Suspense fallback={<p>{t('loading')}</p>}>
        <Routes>
          {planFactoryRoutes.map(({ key, path, authority, component: View }) => (
            <Route
              key={key}
              index={path === ''}
              path={path === '' ? undefined : path}
              element={
                <AuthorityGuard authority={authority} granted={granted}>
                  <View />
                </AuthorityGuard>
              }
            />
          ))}
        </Routes>
      </Suspense>
    </PlanFactoryModuleGate>
  );
}
